import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import PropTypes from 'prop-types'

import Row from '@components/Details/Row'
import DetailsLanguages from '@components/Languages/DetailsLanguages'

class InfoPanel extends Component {
  renderPhones () {
    const { profile, staticData } = this.props
    const { phoneTypes } = staticData.names

    return profile.address.phones.map(phone => (
      <Row
        label={`Phone (${phoneTypes[phone.phoneTypeId]})`}
        text={phone.phoneNum}
      />
    ))
  }

  renderHourlyRate (position) {
    const { currencies } = this.props.staticData.names

    return `${position.hourlyRate} ${currencies[position.currencyId]}`
  }

  renderCurrentPosition = position => {
    const { staticData } = this.props
    const { employeePositions } = staticData.names

    if (!position) return null

    return (
      <div className='story'>
        <span className='label'>Current position</span>
        <div className='group-wrapper'>
          <div className='group'>
            <Row
              label='Role'
              text={employeePositions[position.employeePositionId]}
            />
            <Row
              label='Position description'
              text={position.positionDescription}
            />
            <Row label='Hourly rate' text={this.renderHourlyRate(position)} />
          </div>
        </div>
      </div>
    )
  }

  render () {
    const { profile } = this.props
    const employeeData = profile.employee

    return (
      <div className='content'>
        <div className='col-2'>
          <div className='story'>
            <div className='label'>Professional profile</div>
            <div className='group-wrapper'>
              <div className='group'>
                <DetailsLanguages languages={profile.languages} />
                <Row
                  label='Atheneum office'
                  text={employeeData.atheneumOffice.name}
                />
                <Row
                  label='Position description'
                  text={profile.currentPosition.positionDescription}
                />
              </div>
            </div>
          </div>
          {this.renderCurrentPosition(profile.currentPosition)}
        </div>
        <div className='col-2'>
          <div className='story'>
            <span className='label'>Contact information</span>
            <div className='group-wrapper'>
              <div className='group'>
                {this.renderPhones()}
                <Row label='email' text={profile.email} copiable />
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  static propTypes = {
    profile: PropTypes.object,
    staticData: PropTypes.object
  }
}

export default inject('staticData')(observer(InfoPanel))
